import { ClientErrorCodes, ITmpURL } from '@logicalcommander/types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import deepEqual from 'deep-equal'
import { INotification } from '../../ui/awareComponents/lc-notifications/lc-notifications.interface'
import { RootState } from '../store'

export enum NotificationType {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  NONE = 'NONE',
}

export enum eInitializeState {
  NOT_STARTED = 'NOT_STARTED',
  LOADING = 'LOADING',
  FINISHED = 'FINISHED',
}

export interface IPageHeader {
  icon?: any
  title?: string
  subTitle?: string
  breadcrumbs?: string
  /** Optional video URL for page-specific help video (shown only when Spanish is selected) */
  videoUrl?: string
}

interface GeneralState {
  showLoader: boolean
  logoTmpURL: string
  selectedLanguage: string
  notifications: INotification[]
  initializeState: eInitializeState
  pageHeader?: IPageHeader
  clientErrorCode?: ClientErrorCodes
}

const initialState: GeneralState = {
  showLoader: false,
  selectedLanguage: localStorage.getItem('currentLanguage') || 'en',
  notifications: [],
  logoTmpURL: '',
  initializeState: eInitializeState.NOT_STARTED,
  clientErrorCode: undefined,
}

export const generalSlice = createSlice({
  name: 'generalReducer',
  initialState,
  reducers: {
    showLoader: (state, action: PayloadAction<boolean>) => {
      state.showLoader = action.payload
    },
    changeLanguage: (state, action: PayloadAction<string>) => {
      state.selectedLanguage = action.payload
      localStorage.setItem('currentLanguage', action.payload)
    },
    initCompanyLogoTmpURL: (state, action: PayloadAction<ITmpURL>) => {
      state.logoTmpURL = action.payload.url
    },
    updateNotifications: (state, action: PayloadAction<INotification[]>) => {
      state.notifications = action.payload
    },
    setPageHeader: (state, action: PayloadAction<IPageHeader>) => {
      if (!deepEqual(state.pageHeader, action.payload)) {
        state.pageHeader = { ...action.payload }
      }
    },
    setInitializeState: (state, action: PayloadAction<eInitializeState>) => {
      state.initializeState = action.payload
    },
    setClientErrorCode: (state, action: PayloadAction<ClientErrorCodes | undefined>): void => {
      state.clientErrorCode = action.payload
    },
  },
})

export const {
  showLoader,
  changeLanguage,
  initCompanyLogoTmpURL,
  updateNotifications,
  setPageHeader,
  setInitializeState,
  setClientErrorCode,
} = generalSlice.actions
export default generalSlice.reducer
export const selectGeneral = (state: RootState): GeneralState => state.generalReducer
export const selectPageHeader = (state: RootState): IPageHeader | undefined => state.generalReducer.pageHeader
